import { Button } from 'antd';
import React from 'react';
import { ResetPasswordSuccessWrapper as StyledResetPasswordSuccessWrapper } from './styled';

import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../routes/route.constant';
import IconSvg from 'components/IconSvg';

const ResetPasswordSuccess = () => {
  const navigate = useNavigate();
  return (
    <StyledResetPasswordSuccessWrapper>
      <div className="iconSuccess">
        <IconSvg name="icon-successfully" />
      </div>
      <div className="message">パスワードが正常にリセットされました</div>

      <Button
        style={{
          margin: '24px 0',
          borderRadius: 10,
          backgroundColor: '#ED7836',
        }}
        className="btn-login"
        onClick={() => navigate(ROUTE_PATH.LOGIN)}
      >
        ログイン
      </Button>
    </StyledResetPasswordSuccessWrapper>
  );
};

export default ResetPasswordSuccess;
